import { ISuccessCardProps } from "./SuccessCardTypes"

import { Flex, Text } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"
import { useUI } from "providers/UIProvider"
import { IRoles } from "types/shared"
import { useAppContext } from "providers/AppProvider/AppProvider"

const SuccessCard: React.FC<ISuccessCardProps> = () => {
  const { userRole } = useAppContext()
  const { T } = useUI()
  const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole);



  return (
    <Flex w="100%" h="100%" bg="white" justifyContent="center" alignItems="center" flexDirection="column">
      <Icon name="checkmark_outline" iconStyles={{ width: "160px", height: "160px", fill: "var(--chakra-colors-success)" }} />
      {isQappUser ? <Text mt="40px" fontWeight="600" fontSize="xl">{T("general.success_message")}</Text> :
        <Text mt="40px" fontWeight="600" fontSize="xl">{T("laundry.update_success_message")}</Text>
      }
    </Flex>
  )
}

export default SuccessCard;